import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import styled from 'styled-components';

const defaultProps = {
    count: 1,
    duration: 1.2,
    width: null,
    height: null,
    circle: false,
    color: null,
    highlightColor: null,
    spaceBetween: '8px',
    className: '',
    dataTestId: '',
};

interface LoadingSkeletonProps {
    count?: number;
    duration?: number;
    width?: string | number;
    height?: string | number;
    circle?: boolean;
    color: string;
    highlightColor: string;
    spaceBetween: string | number;
    className: string;
    dataTestId: string;
}

const LoadingSkeleton = ({
    count,
    duration,
    width,
    height,
    circle,
    color,
    highlightColor,
    spaceBetween,
    className,
    dataTestId,
}: LoadingSkeletonProps) => {
    const skeletonBarWithMargin = marginBottom => (_, id) => (
        <StyledDiv marginBottom={marginBottom} key={id}>
            <Skeleton
                duration={duration}
                width={width}
                height={height}
                circle={circle}
            />
        </StyledDiv>
    );

    const spacedBars = [
        ...Array.from(new Array(count - 1))
            .map(skeletonBarWithMargin(spaceBetween)),
        skeletonBarWithMargin('0px')(null, count),
    ];

    return (
        <Wrapper className={className} data-testid={dataTestId}>
            <SkeletonTheme color={color} highlightColor={highlightColor}>
                {spacedBars}
            </SkeletonTheme>
        </Wrapper>
    );
};

const Wrapper = styled.div``;

const StyledDiv = styled.div`
    margin-bottom: ${({ marginBottom }) => marginBottom};
`;

LoadingSkeleton.defaultProps = defaultProps;

export default LoadingSkeleton;
